import { CONFIG } from "core/config";
import { getToken } from "core/services/Storage";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { io, Socket } from "socket.io-client";

const { chatUrl } = CONFIG;

interface SocketContextValue {
  socket: Socket | null;
}

const SocketContext = createContext<SocketContextValue>({ socket: null });

interface SocketProviderProps {
  children: ReactNode;
}

export const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const updateToken = () => {
      const tokenFromCookie = getToken();
      setToken(tokenFromCookie);
    };

    updateToken();

    const handleTokenUpdated = () => updateToken();

    window.addEventListener("token-updated", handleTokenUpdated);

    return () => {
      window.removeEventListener("token-updated", handleTokenUpdated);
    };
  }, []);

  useEffect(() => {
    if (!token) return;

    const newSocket = io(chatUrl, {
      auth: { token },
      transports: ["websocket"],
    });

    newSocket.on("connect", () => {});

    newSocket.on("connect_error", (err) => {});

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
      setSocket(null);
    };
  }, [token]);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error("useSocket must be used within a SocketProvider");
  }
  return context.socket;
};
